module.exports = __webpack_public_path__ + "static/spinAFriend-26f9bed01863865280100ac0a934ea45.png";